import React, { useState, useEffect } from 'react';
import { Select, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { trIncludes } from '../../../utils/trText';

const { Option } = Select;

const LocationFilters = ({ filters, onChange, onBatchChange, darkMode }) => {
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [loadingDistricts, setLoadingDistricts] = useState(false);

  const { API_BASE_URL: SHARED_API_BASE_URL } = require('../../../utils/config');
  const API_BASE_URL = SHARED_API_BASE_URL;

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/atm/query?filters=${encodeURIComponent(JSON.stringify([{"field": "fetch", "value": "iller"}]))}`);
        if (response.ok) {
          const data = await response.json();
          const provincesData = data.data || [];
          const formattedProvinces = provincesData.map(p => ({
            id: p.il_no,
            name: p.il_ad
          }));
          setProvinces(formattedProvinces);
        } else {
          console.error('Failed to fetch provinces');
        }
      } catch (error) {
        console.error('Error fetching provinces:', error);
        setProvinces([
          { id: 34, name: 'İstanbul' },
          { id: 6, name: 'Ankara' },
          { id: 35, name: 'İzmir' }
        ]);
      }
    };
    
    fetchProvinces();
  }, []);

  const handleProvinceChange = async (provinceId) => {
    if (onBatchChange) {
      onBatchChange({ provinceId, districtId: null });
    } else {
      onChange('provinceId', provinceId);
      onChange('districtId', null);
    }
    
    if (provinceId) {
      setLoadingDistricts(true);
      
      try {
        const response = await fetch(`${API_BASE_URL}/atm/query`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify([
            {"field": "fetch", "value": "ilceler"},
            {"field": "il", "value": provinceId}
          ])
        });
        if (response.ok) {
          const data = await response.json();
          const districtsData = data.data || [];
          const formattedDistricts = districtsData.map(d => ({
            id: d.ID || d.id,
            name: d.Name || d.name
          }));
          setDistricts(formattedDistricts);
        } else {
          console.error('Failed to fetch districts');
          setDistricts([]);
        }
      } catch (error) {
        console.error('Error fetching districts:', error);
        setDistricts([]);
      } finally {
        setLoadingDistricts(false);
      }
    } else {
      setDistricts([]);
    }
  };

  const handleDistrictChange = (districtId) => {
    onChange('districtId', districtId);
  };

  const handleSearchChange = (e) => {
    onChange('searchText', e.target.value);
  };

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          İl Seçin
        </label>
        <Select
          style={{ width: '100%' }}
          placeholder="İl seçin"
          value={filters.provinceId}
          onChange={handleProvinceChange}
          allowClear
          showSearch
          filterOption={(input, option) =>
            trIncludes(option.children, input)
          }
        >
          {provinces.map(province => (
            <Option key={province.id} value={province.id}>
              {province.name}
            </Option>
          ))}
        </Select>
      </div>

      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          İlçe Seçin
        </label>
        <Select
          style={{ width: '100%' }}
          placeholder={filters.provinceId ? "İlçe seçin" : "Önce il seçin"}
          value={filters.districtId}
          onChange={handleDistrictChange}
          disabled={!filters.provinceId}
          loading={loadingDistricts}
          allowClear
          showSearch
          filterOption={(input, option) =>
            trIncludes(option.children, input)
          }
        >
          {districts.map(district => (
            <Option key={district.id} value={district.id}>
              {district.name}
            </Option>
          ))}
        </Select>
      </div>

      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Lokasyon Adı
        </label>
        <Input
          placeholder="Lokasyon adı veya ID ara"
          prefix={<SearchOutlined />}
          value={filters.searchText}
          onChange={handleSearchChange}
          allowClear
        />
      </div>
    </Space>
  );
};

export default LocationFilters;
